export enum RouteEnum {
	Home = 'home',
	Login = 'login',
	RegistrationConfirm = 'registration-confirm',
	Blogs = 'blogs',
	HistoricalHeritage = 'historical-heritage',
	PPSCards = 'pps-cards',
	PPSCardMembership = 'pps-membership',
	Authenticity = 'authenticity-countries',
	Categories = 'categories-tabs',
	User = 'user',
	PhobsProperties = 'phobs-properties',
}

export const routes = {
	[RouteEnum.Home]: '/',
	[RouteEnum.Login]: `/${RouteEnum.Login}`,
	[RouteEnum.RegistrationConfirm]: `/${RouteEnum.RegistrationConfirm}`,
	[RouteEnum.Blogs]: `/${RouteEnum.Blogs}`,
	[RouteEnum.HistoricalHeritage]: `/${RouteEnum.HistoricalHeritage}`,
	[RouteEnum.PPSCards]: `/${RouteEnum.PPSCards}`,
	[RouteEnum.PPSCardMembership]: `/${RouteEnum.PPSCardMembership}`,
	[RouteEnum.Authenticity]: `/${RouteEnum.Authenticity}`,
	[RouteEnum.Categories]: `/${RouteEnum.Categories}`,
	[RouteEnum.User]: `/${RouteEnum.User}`,
	[RouteEnum.PhobsProperties]: `/${RouteEnum.PhobsProperties}`,
}

export enum CrudEnum {
	Create = 'create',
	Read = 'read',
	Update = 'update'
}